/*
Agência Dropi - Ecomm & Dropshipping | Dev @ Dropi - agenciadropi.com.br
Tema Dropi. Se comprado em sites de terceiros sem licença oficial, estará sujeito a processos judiciais e inativação da sua loja.
*/

(function(){

  function getCurrency(){
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return 'BRL';
  }

  function formatMoney(cents){
    return (cents/100).toLocaleString('pt-BR',{
      style:'currency',
      currency: getCurrency()
    });
  }

  function animateBar(bar,start,end){
    const dur=500,startTime=performance.now();
    function frame(now){
      const t=Math.min(1,(now-startTime)/dur),
            e=start+(end-start)*(1-Math.pow(1-t,3));
      bar.style.width=e+'%';
      if(t<1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function update(wrapper,cartTotal){
    if(!wrapper) return;
    if(!cartTotal || cartTotal <= 0){ 
      wrapper.style.display = 'none'; 
      return; 
    }

    wrapper.style.display='block';

    const threshold = parseInt(wrapper.dataset.threshold),
          titleDefault = wrapper.dataset.title || "Falta pouco para ganhar Frete Grátis!";

    const messageEl = wrapper.querySelector('[data-message]'),
          headerEl = wrapper.querySelector('.free-shipping-header'),
          progressBar = wrapper.querySelector('[data-progress]');

    const percent = Math.min(100, (cartTotal/threshold)*100);

    if(progressBar){
      const cssBarColor = getComputedStyle(document.documentElement)
                            .getPropertyValue('--color-secondary-button-background')
                            .trim() || '#16a34a';
      const finalBarColor = wrapper.dataset.barColor || cssBarColor;
      animateBar(progressBar, parseFloat(progressBar.style.width) || 0, percent);
      progressBar.style.backgroundColor = finalBarColor;
    }

    if(cartTotal>=threshold){
      if(messageEl) messageEl.innerHTML="Só alegria! O frete é por nossa conta.";
      if(headerEl) headerEl.innerHTML="🎉 Você ganhou Frete Grátis!";
    } else {
      const remaining = threshold - cartTotal;
      if(messageEl){
        messageEl.innerHTML="Adicione mais <strong>"+
          formatMoney(Math.max(remaining,0))+
          "</strong> e aproveite!";
      }
      if(headerEl) headerEl.innerHTML="🚚 "+titleDefault;
    }
  }

  async function refreshCartWrapper(){
    const drawer=document.querySelector('.cart-drawer');
    if(!drawer) return;
    const wrapper=drawer.querySelector('.free-shipping-wrapper');
    if(!wrapper) return;

    try{
      const res=await fetch('/cart.js',{cache:'no-store'});
      const cart=await res.json();
      update(wrapper,cart.total_price||0);
    }catch(e){
      console.warn('Erro ao atualizar barra de frete grátis',e);
    }
  }

  refreshCartWrapper();

  const drawer=document.querySelector('.cart-drawer');
  if(drawer){
    const observer=new MutationObserver(()=>refreshCartWrapper());
    observer.observe(drawer,{childList:true,subtree:true});
  }

  const originalFetch=window.fetch;
  window.fetch=async function(){
    const response=await originalFetch.apply(this,arguments);
    if(arguments[0] && typeof arguments[0]==='string'){
      if(arguments[0].includes('/cart/add') ||
         arguments[0].includes('/cart/change') ||
         arguments[0].includes('/cart/update')){
        setTimeout(refreshCartWrapper,200);
      }
    }
    return response;
  }

  document.addEventListener('submit',function(e){
    if(e.target.action && e.target.action.includes('/cart/add')){
      setTimeout(refreshCartWrapper,500);
    }
  });

})();
